import { render, staticRenderFns } from "./BaseChevron.vue?vue&type=template&id=1f88d04e&functional=true&"
import script from "./BaseChevron.vue?vue&type=script&lang=ts&"
export * from "./BaseChevron.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChevron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports